import React, { useState, useEffect } from "react";
import axiosInstance from "../../utils/axiosInstance";
import "../../styles/SlideShowManagement.css";

const SlideShowManagement = () => {
  const [imageURL, setImageURL] = useState("");
  const [description, setDescription] = useState("");
  const [slides, setSlides] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(null);

  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const res = await axiosInstance.get("/slides");
        setSlides(res.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchSlides();
  }, []);

  const handleImageURLChange = (e) => {
    setImageURL(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = { imageURL, description, date: new Date() };

    try {
      await axiosInstance.post("/slides", formData);
      const res = await axiosInstance.get("/slides");
      setSlides(res.data);
      setImageURL("");
      setDescription("");
    } catch (err) {
      console.error("Submit Error:", err.response ? err.response.data : err);
    }
  };

  const handleDelete = async () => {
    try {
      await axiosInstance.delete(`/slides/${currentSlide._id}`);
      const res = await axiosInstance.get("/slides");
      setSlides(res.data);
      setShowDeleteModal(false);
    } catch (err) {
      console.error("Delete Error:", err);
    }
  };

  const handleEdit = async () => {
    try {
      await axiosInstance.put(`/slides/${currentSlide._id}`, {
        imageURL: currentSlide.imageURL,
        description: currentSlide.description,
      });
      const res = await axiosInstance.get("/slides");
      setSlides(res.data);
      setShowEditModal(false);
    } catch (err) {
      console.error("Edit Error:", err);
    }
  };

  return (
    <div className="slideshow-management">
      <div className="slideshow-header">
        <h3>Manage Slide Show</h3>
      </div>

      <div className="add-slide-card">
        <h4>Add New Slide</h4>
        <form onSubmit={handleSubmit} className="add-slide-form">
          <div className="form-group">
            <label>Image URL</label>
            <input
              type="text"
              value={imageURL}
              onChange={handleImageURLChange}
              placeholder="https://example.com/image.jpg"
              required
            />
          </div>
          <div className="form-group">
            <label>Description</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter a description for this slide..."
              required
            ></textarea>
          </div>
          <button type="submit" className="add-btn">Add Slide</button>
        </form>
      </div>

      <div className="slides-grid-container">
        <h4>Current Slides ({slides.length})</h4>
        <div className="slides-grid">
          {slides.map((slide) => (
            <div key={slide._id} className="slide-card">
              <div className="slide-image-container">
                <img src={slide.imageURL} alt={slide.description} />
                <div className="slide-overlay">
                  <span className="slide-date">{new Date(slide.createdAt).toLocaleDateString()}</span>
                </div>
              </div>
              <div className="slide-content">
                <p className="slide-description">{slide.description}</p>
                <div className="slide-actions">
                  <button
                    className="action-btn edit"
                    onClick={() => {
                      setCurrentSlide(slide);
                      setShowEditModal(true);
                    }}
                  >
                    Edit
                  </button>
                  <button
                    className="action-btn delete"
                    onClick={() => {
                      setCurrentSlide(slide);
                      setShowDeleteModal(true);
                    }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))}
          {slides.length === 0 && (
            <div className="no-slides">No slides added yet.</div>
          )}
        </div>
      </div>

      {/* Delete Modal */}
      {showDeleteModal && (
        <div className="modal-overlay" onClick={() => setShowDeleteModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h4>Delete Slide</h4>
              <button className="close-btn" onClick={() => setShowDeleteModal(false)}>×</button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to delete this slide?</p>
              <div className="preview-image">
                <img src={currentSlide.imageURL} alt="Preview" />
              </div>
              <p className="preview-desc">{currentSlide.description}</p>
            </div>
            <div className="modal-footer">
              <button className="cancel-btn" onClick={() => setShowDeleteModal(false)}>Cancel</button>
              <button className="delete-confirm-btn" onClick={handleDelete}>Delete</button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {showEditModal && (
        <div className="modal-overlay" onClick={() => setShowEditModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h4>Edit Slide</h4>
              <button className="close-btn" onClick={() => setShowEditModal(false)}>×</button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label>Image URL</label>
                <input
                  type="text"
                  value={currentSlide.imageURL}
                  onChange={(e) =>
                    setCurrentSlide({ ...currentSlide, imageURL: e.target.value })
                  }
                />
              </div>
              <div className="form-group">
                <label>Description</label>
                <textarea
                  value={currentSlide.description}
                  onChange={(e) =>
                    setCurrentSlide({ ...currentSlide, description: e.target.value })
                  }
                ></textarea>
              </div>
            </div>
            <div className="modal-footer">
              <button className="cancel-btn" onClick={() => setShowEditModal(false)}>Cancel</button>
              <button className="save-btn" onClick={handleEdit}>Save Changes</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SlideShowManagement;
